#import "./CompanyConfigurationCategoriesFields.graphql"

query CompanyConfigurationCategories {
  companyConfigurationCategories(orderBy: SORT_ORDER_ASC) {
    nodes {
      ...CompanyConfigurationCategoriesFields
    }
  }
}
